import { createApp } from 'vue'
import Editor from './App.vue'
import './scss/index.scss'

createApp(Editor).mount('#app')
